/**
 * Browser tab title helpers.
 */
import { APP_NAME, APP_TAGLINE } from '../config/appInfo';

export function buildDocumentTitle(customerName) {
  if (customerName) {
    return `${APP_NAME} — ${customerName}`;
  }
  return `${APP_NAME} — ${APP_TAGLINE}`;
}

export function setDocumentTitle(customerName) {
  if (typeof document === 'undefined') {
    return;
  }
  document.title = buildDocumentTitle(customerName);
}
